// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Controller Rollout API
 * Fleet-wide view and control of Rollout CRDs across orchestras
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ResponseActionAck
 */
export interface ResponseActionAck {
  /**
   *
   * @type {number}
   * @memberof ResponseActionAck
   */
  actionId?: number;
  /**
   *
   * @type {string}
   * @memberof ResponseActionAck
   */
  rolloutIdentifier?: string;
}

/**
 * Check if a given object implements the ResponseActionAck interface.
 */
export function instanceOfResponseActionAck(
  value: object,
): value is ResponseActionAck {
  return true;
}

export function ResponseActionAckFromJSON(json: any): ResponseActionAck {
  return ResponseActionAckFromJSONTyped(json, false);
}

export function ResponseActionAckFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResponseActionAck {
  if (json == null) {
    return json;
  }
  return {
    actionId: json['actionId'] == null ? undefined : json['actionId'],
    rolloutIdentifier:
      json['rolloutIdentifier'] == null ? undefined : json['rolloutIdentifier'],
  };
}

export function ResponseActionAckToJSON(json: any): ResponseActionAck {
  return ResponseActionAckToJSONTyped(json, false);
}

export function ResponseActionAckToJSONTyped(
  value?: ResponseActionAck | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    actionId: value['actionId'],
    rolloutIdentifier: value['rolloutIdentifier'],
  };
}
